export const FETCH_DSP_USER_FAILURE = "FETCH_DSP_USER_FAILURE";
export const FETCH_DSP_USER_REQUEST = "FETCH_DSP_USER_REQUEST";
export const FETCH_DSP_USER_SUCCESS = "FETCH_DSP_USER_SUCCESS";